import { FC, type ReactElement } from 'react';
import toastLoadingIcon from '@assets/images/parrot/toast-loading.svg';
import viewIcon from '@assets/images/parrot/view.svg';
import styles from './index.module.scss';
import { globalSettingModel } from '@models/global-setting.model';
import { Link } from 'react-router-dom';

interface OwnProps {
  description: string | ReactElement;
  time: number;
  digest: string;
}

const ToastSuccess: FC<OwnProps> = ({ description, time, digest }) => {
  return (
    <div className={styles.wrapper}>
      <img src={toastLoadingIcon} />
      <div>
        <div className={styles.description}>{description}</div>
        <div className={styles.time}>Finalized in {time} seconds</div>
        <Link
          className={styles.view}
          to={globalSettingModel.explorerUrlForTransaction(digest)}
          target="_blank"
        >
          View on Explorer <img src={viewIcon} data-icon />
        </Link>
      </div>
    </div>
  );
};

export default ToastSuccess;
